import { format, parse } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const formatDateInPT = (
  date?: Date,
  formatString: string = 'MM/dd/yyyy'
) =>
  format(toZonedTime(date ?? new Date(), 'America/Los_Angeles'), formatString);

export const getDateOnly = (
  date?: string,
  formatString: string = 'MM/dd/yyyy'
) => {
  if (!date) return '';
  const dateStringOnly = date.split('T')[0];
  const dateOnly = parse(dateStringOnly, 'yyyy-MM-dd', new Date());
  return format(dateOnly, formatString);
};
